<template>
  <v-row align="center" justify="center">
    <v-col cols="10">
      <v-card>
        <v-card-text class="pa-0 background">
          <v-row class="py-6">
            <v-col cols="5" class="pt-0">
              <v-img contain :src="require('@/assets/appAsset-setup--Check.svg')" height="400" />
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>
                    <v-icon left small color="primary">mdi-check</v-icon>
                    <span class="ml-1 body-2 text--secondary font-weight-medium">Automatiza tu facturación</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-icon left small color="primary">mdi-check</v-icon>
                    <span class="ml-1 body-2 text--secondary font-weight-medium">Gestiona tus suscripciones</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-icon left small color="primary">mdi-check</v-icon>
                    <span class="ml-1 body-2 text--secondary font-weight-medium">Experimenta diferentes modos de cobro</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-icon left small color="primary">mdi-check</v-icon>
                    <span class="ml-1 body-2 text--secondary font-weight-medium">Analiza detalladamente tus ingresos</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="7">
              <v-list dense class="transparent">
                <v-list-item class="my-3">
                  <v-list-item-content>
                    <v-list-item-title class="body-1 text--secondary font-weight-medium">1. ¿Cúal es el país donde opera la compañía?</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="6" class="pl-0">
                        <v-select v-model="$v.newAccount.country.$model" :error="$v.newAccount.country.$error" :items="baseCountries" single-line item-text="name" item-value="id" hide-details dense height="30" outlined background-color="white" />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 text--secondary font-weight-medium">2. ¿Cúal es el nombre de la compañía?</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="8" class="pl-0">
                        <v-text-field v-model.trim="$v.newAccount.name.$model" :error="$v.newAccount.name.$error" background-color="white" outlined required single-line dense maxlength="64" hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 text--secondary font-weight-medium">3. Número fiscal</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="8" class="pl-0">
                        <v-text-field v-model.trim="$v.newAccount.tax_id.$model" :error="$v.newAccount.tax_id.$error" v-dni="newAccount.country" background-color="white" outlined required single-line dense maxlength="64" hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 text--secondary font-weight-medium">4. ¿Cúal es la forma de cobro?</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="8" class="pl-0" style="position: absolute">
                        <div v-for="d in chargeSchemes" :key="d.value">
                          <v-radio-group hide-details v-model="$v.newAccount.charge_scheme.$model" class="my-2">
                            <v-radio :label="d.label" :value="d.value" />
                          </v-radio-group>
                        </div>
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer/>
          <v-btn @click="postAccount" :loading="$store.state.accounts.createLoader" color="primary">Crear una nueva organización</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, requiredIf, minLength, maxLength } from 'vuelidate/lib/validators'
import { rutValidator } from 'vue-dni'
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  mixins: [
    GenericViewMixin
  ],
  data () {
    return {
      newAccount: {
        country: '',
        name: '',
        tax_id: '',
        charge_scheme: ''
      },
      chargeSchemes: [
        { value: 'recurring', label: 'Cobro recurrente, por suscripción o membresía' },
        { value: 'transactional', label: 'Transaccional (intercambio de producto por dinero)' },
        { value: 'commission', label: 'Comisionista' }
      ]
    }
  },
  computed: {
    chargeScheme () {
      if (this.newAccount.charge_scheme) {
        return this.chargeSchemes.find(d => d.value === this.newAccount.charge_scheme).label
      }
      return ''
    },
    ...mapState({
      trace: state => state.auth.trace
    })
  },
  watch: {
    'newAccount.country' () {
      this.newAccount.tax_id = ''
    }
  },
  created () {
    this.$store.dispatch('auth/RETRIEVE_TRACE')
    .then(() => {
      this.newAccount.country = this.trace.loc
    })
  },
  methods: {
    group (account) {
      /**
       * runs group
       * it runs as long as the env is production
       */
      if (process.env.NODE_ENV !== 'production') {
        return false
      }

      const traits = {
        name: account.name,
        tax_id: account.tax_id,
        createdAt: account.created
      }

      this.$analytics.group(account.id, traits)
    },
    postAccount () {
      this.$v.newAccount.$touch()
      if (this.$v.newAccount.$invalid) {
        return false
      }
      this.$store.dispatch('accounts/CREATE', {
        resource: 'accounts',
        payload: this.newAccount
      })
      .then((response) => {
        const account = response.data

        this.group(account)

        this.$store.commit('auth/SET_ACCOUNT', {
          account: account,
          redirect: false
        })

        this.$router.push({ name: 'AccountQuickstart' })
      })
      .catch((error) => {
        this.$dialog.message.error(error.response.data.tax_id[0] || 'Error al crear la cuenta')
      })
    },
    validateAccount () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return false
      }
      return true
    }
  },
  validations: {
    newAccount: {
      country: {
        required
      },
      name: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(64)
      },
      tax_id: {
        required: requiredIf(function () {
          const country = this.baseCountries.find(country => country.id === this.newAccount.country)
          if (!country) {
            return false
          }
          return country.hasRegulation
        }),
        taxId: function (val) {
          if (this.newAccount.country === 'CL') {
            return rutValidator(val)
          }
          return true
        },
        maxLength: maxLength(32)
      },
      charge_scheme: {
        required
      }
    }
  }
}
</script>